/* src/app/layout/empty-layout/empty-layout.component.scss */
/*# sourceMappingURL=empty-layout.component-TKFTZDBR.css.map */
